import { render } from "./Artboard_AlbumReview.vue?vue&type=template&id=64aff05a&scoped=true"
import script from "./Artboard_AlbumReview.vue?vue&type=script&lang=js"
export * from "./Artboard_AlbumReview.vue?vue&type=script&lang=js"

import "./Artboard_AlbumReview.vue?vue&type=style&index=0&id=64aff05a&scoped=true&lang=css"
import "./Artboard_AlbumReview.vue?vue&type=style&index=1&id=64aff05a&lang=css"
script.render = render
script.__scopeId = "data-v-64aff05a"

export default script